import { Component, ElementRef, ViewChild, OnInit, OnDestroy, Input, EventEmitter, ChangeDetectorRef, OnChanges, SimpleChanges, HostListener } from '@angular/core';
import { RouterModule, ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { CommonModule, NgIf } from '@angular/common';
import { TabsComponent } from '../tabs/tabs.component';
import { NavLinksService } from '../service/nav-links.service';
import { ReduxApiHandlerService } from '../service/state-api-handler.service';
import { UserService } from '../service/user.service';
import { SidebarService } from '../service/sidebar.service';
import { MenuService } from '../service/menu.service';
import { Subscription } from 'rxjs';
import { StateService } from '../service/state.service';
import { LoginService } from '../service/login.service';
import { AlertPopupComponent } from '../components/alert-popup/alert-popup.component';
import { ClientNameService } from '../service/client-name.service';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-layout',
  standalone: true,
  imports: [RouterModule, CommonModule, TabsComponent, AlertPopupComponent,NgIf],
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.css']
})
export class LayoutComponent implements OnInit, OnChanges, OnDestroy {
  @Input() sidebarToggle?: EventEmitter<void>;
  @ViewChild('sidebar', { static: true }) sidebar!: ElementRef;
  public navLinks: any[] = [];
  userId: number = 0;
  Role: string = '';
  currentRoute?: string;
  CustomerId: number = 0;
  firstName?: string;
  lastName?: string;
  ClientId?: string;
  clientName?: string;
  sidebarActive = true;
  toggleimg = '../assets/vectors/SidebarToggleoff.svg'
  logoImageUrl = './assets/Images/TeamLeaseRegtech_Logo_new.png';
  logoImageClass = 'nav-open-logo';
  svgIcon = `../assets/vectors/Reports.svg`;
  isFirstLogin = true;
  isEntityFirst = true;
  CustomerName = '';
  isActive: boolean = false;
  subscription!: Subscription;
  // Router event subscriptions — must be torn down in ngOnDestroy. The layout sits inside
  // *ngIf="showContent" in app.component.html, so it is destroyed/recreated as the user moves
  // between content and Login/Error routes. Without unsubscribing, each recreation leaves a
  // live router.events subscription behind, so NavigationEnd (and loadSidebarLinks →
  // GetMenuBasedOnRole) fires once per stacked subscription.
  routerEventsSub?: Subscription;
  alertData = { alertMessage: '', alertVisible: '' }
  sidebarTabMenuToggle = false;
  entityText: string = '';
  showProfileDropdown: boolean = false;
  sidebarTabMenuToggleELibrary: boolean = false;
  sidebarTabMenuToggleWorkspace = false;
  sidebarTabMenuToggleAuditScreen = false;
  sidebarTabMenuToggleReturnsActivity = false;
  selectedMenu: any
  selectedNavLink: any
  sidebarToggleSubscription?: Subscription;

  constructor(
    private navLinksService: NavLinksService,
    private userService: UserService,
    private route: ActivatedRoute,
    private router: Router,
    private loginService: LoginService,
    private sidebarService: SidebarService,
    private cdr: ChangeDetectorRef,
    private menuService: MenuService,
    private stateService: StateService,
    private ClientName: ClientNameService,
    private cd: ChangeDetectorRef,
    private reduxApiHandler: ReduxApiHandlerService
  ) { }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event) {
    const target = event.target as HTMLElement;
    if (!target.closest('.profile-container') && !target.closest('.toggle-Profile')) {
      this.showProfileDropdown = false;
    }
  }
  ngAfterViewInit() {
    setTimeout(() => {
      this.sidebarToggleSubscription = this.sidebarService.sidebarToggle$.subscribe(() => {
        this.toggleSidebar(!this.sidebarActive);
      });
    }, 0);
  }
  ngOnDestroy() {
    this.sidebarToggleSubscription?.unsubscribe();
    this.subscription?.unsubscribe();
    // Tear down the router event subscriptions so a recreated layout (via the
    // *ngIf="showContent" toggle) does not leave a duplicate handler firing
    // loadSidebarLinks/GetMenuBasedOnRole on every NavigationEnd.
    this.routerEventsSub?.unsubscribe();
  }
  ngOnInit(): void {
    // window.addEventListener('popstate', this.onBackClick.bind(this));

    setTimeout(() => {
      if (!sessionStorage.length && !localStorage.length && this.router.url != "/Login") {
        this.logOut();
      }
    }, 5000);
   
    this.ClientName.currentClientName$.subscribe(clientName => {
      this.clientName = clientName;
    })
    this.currentRoute = this.router.url;
    this.AssignSession();
    if (this.isSidebarClosedRoute(this.currentRoute)) {
      this.toggleSidebar(true);
    } else {
      this.loadSidebarLinks();
    }

    this.routerEventsSub = this.router.events.subscribe(
      (event: any) => {
        if (event instanceof NavigationEnd) {
          this.currentRoute = this.router.url;
          if (this.currentRoute.split('?')[0] == '/Auth' || this.isSidebarClosedRoute(this.currentRoute)) {
            this.navLinks = [];
            this.toggleSidebar(true);
            this.CustomerName = '';
            this.ClientId = '';
          } else {
            this.toggleSidebar(false);
             this.AssignSession();
              this.loadSidebarLinks();
          }

          this.cdr.detectChanges();
        }

        this.cdr.detectChanges();
      }
    );

    this.subscription = this.stateService.isEnabled$.subscribe((value: boolean) => {
      this.isActive = value;
    });
    this.cdr.detectChanges();
  }

  gotoEntityDashboard() {
    this.router.navigate(['/CustomerDashboard']);
  }

  toggleProfileDropdown() {
    this.showProfileDropdown = !this.showProfileDropdown;
  }
  navigateTo(path: string) {
    if (!path) return;
    const cleanPath = path.replace(/^\//, '');
    this.router.navigate([cleanPath]);
  }
  toggleParent(selected: any) {
    this.navLinks.forEach(link => {
      link.isOpen = link === selected ? !link.isOpen : false;
    });
  }

  toggleChild(parent: any, selectedChild: any) {
    parent.children.forEach((c: any) => {
      c.isOpen = c === selectedChild ? !c.isOpen : false;
    });
  }

  buildSidebarTree(data: any[]) {
    const map = new Map<number, any>();
    const menuIDMap = new Map<string, any>();
    const roots: any[] = [];

    // Create map keyed by both id and menuID
    data.forEach(item => {
      const node = { ...item, children: [], isOpen: false };
      map.set(item.id, node);
      menuIDMap.set(item.menuID, node);
    });

    // Build tree — lookup parent by menuID string (e.g. "M07")
    data.forEach(item => {

      if (item.parentMenuID) {
        const parent = menuIDMap.get(item.parentMenuID);
        parent?.children.push(map.get(item.id));
      } else {
        roots.push(map.get(item.id));
      }

    });
    this.cdr.detectChanges();
    return roots;
  }

    ngOnChanges(changes: SimpleChanges): void {  }

  // setNavName() {
  //   this.ClientId = `[${this.userService.getClientId()}]`;
  //   this.CustomerName = this.userService.getClientName();
  // }

  // @HostListener('window:beforeunload', ['$event'])
  // onBeforeUnload(event: Event) {
  //    this.logOut();
  // }
  logOut() {
    this.loginService.LogoutJTIUpdate(this.userService.getAccessToken()).subscribe({
      next: () => {
        localStorage.clear();
        sessionStorage.clear();
        if (environment.isLogoOutFromLive === '1') {
          window.location.href = 'https://login.teamleaseregtech.com/logout.aspx';
        } else {
          window.location.href = '/Login';
        }
      },
      error: () => {
        localStorage.clear();
        sessionStorage.clear();
        if (environment.isLogoOutFromLive  === '1') {
          window.location.href = 'https://login.teamleaseregtech.com/logout.aspx';
        } else {
          window.location.href = '/Login';
        }
      }
    });
  }
  loadSidebarLinks() {
    if (this.Role && this.CustomerId && sessionStorage.getItem('IsRedirectToMW') != '1' && sessionStorage.getItem('IsRedirectToHM') != '1') {
      // Cache-first via NgRx: the menu only depends on Role/CustomerId/UserId (fixed for the
      // session), so the HTTP call fires once and every later navigation is served from the
      // store. The endpoint string (incl. query params) is the cache key, so a customer/role
      // switch naturally produces a fresh fetch and never serves a stale menu.
      const hmacPayload = { Role: this.Role, CustomerId: this.CustomerId, UserId: this.userId };
      const endpoint = `/api/MenuHandler/GetMenuBasedOnRole?Role=${this.Role}&CustomerId=${this.CustomerId}&UserId=${this.userId}`;
      this.reduxApiHandler.fetchWithCache<any>(endpoint, hmacPayload).subscribe({
        next: (cached) => {
          // Generic effect wraps array responses as { data, total }; unwrap and deep-clone so
          // tree-building never mutates the cached store object.
          const menu = cached?.data ?? cached;
          this.navLinks = this.buildSidebarTree(menu ? JSON.parse(JSON.stringify(menu)) : []);
          this.restoreOpenParent();
        },
        error: (error) => {
          console.error('Error fetching sidebar data', error);
        }
      });
    } else {
      console.warn("Missing Role, CustomerId or SpID");
    }
  }

  private restoreOpenParent(): void {
    const currentPath = '/' + (this.currentRoute?.split('?')[0].split('/')[1] || '');
    this.navLinks.forEach(link => {
      if (link.children?.some((child: any) => child.hrefurl === currentPath)) {
        link.isOpen = true;
      }
    });
  }


  toggleSidebar(open: boolean) {
    if (this.sidebar?.nativeElement) {
      const sidebarElement = this.sidebar.nativeElement as HTMLElement;
      if (open) {
        sidebarElement.classList.add('active');
      } else {
        sidebarElement.classList.remove('active');
      }

      this.sidebarActive = open;

      if (this.sidebarActive) {
        this.toggleimg = '../assets/vectors/SidebarToggleoff.svg'
        this.logoImageUrl = './assets/Images/TeamLease-small.png';
        this.logoImageClass = 'nav-close-logo';
      } else {
        this.toggleimg = '../assets/vectors/SidebarToggle.svg'
        this.logoImageUrl = './assets/Images/TeamLeaseRegtech_Logo_new.png';
        this.logoImageClass = 'nav-open-logo';
      }

      const sidebarBtn = document.querySelector('.sidebarBtn') as HTMLElement;
      if (sidebarBtn) {
        if (this.currentRoute === '/CustomerDashboard' ) {
          this.ClientId = '';
          this.CustomerName = '';
          if (sidebarElement.classList.contains('active')) {
            sidebarBtn.classList.replace('bx-menu-alt-right', 'bx-menu');
          } else {
            sidebarBtn.classList.replace('bx-menu', 'bx-menu-alt-right');
          }
        } else {
          sidebarBtn.classList.replace('bx-menu', 'bx-menu-alt-right');
        }
      }

      const containerContent = document.querySelector('.container-content') as HTMLElement;
      if (containerContent) {
        if (sidebarElement.classList.contains('active')) {
          containerContent.classList.add('sidebar-active');
        } else {
          containerContent.classList.remove('sidebar-active');
        }
      }
    }
  }

  AssignSession() {
    this.firstName = this.userService.getFirstName();
    this.lastName = this.userService.getLastName();
    this.userId = this.userService.getUserId();
    this.Role = this.userService.getRole();
    this.CustomerId = this.userService.getCustomerId();
    this.ClientId = this.userService.getFirstName();
    this.CustomerName = this.userService.getCustomerName();
  }
  private isHiddenRoute(): boolean {
    const hiddenRoutes = ['/CustomerDashboard'];
    return hiddenRoutes.includes(this.currentRoute?.split('?')[0] || '');
  }

  private isHiddenRole(): boolean {
    const hiddenRoles = ['SPADM'];
    return hiddenRoles.includes(this.userService.getRole());
  }

  showCustomerName(): boolean {
    return !this.isHiddenRoute() && !this.isHiddenRole();
  }
  onSubSidebarLinkClick(linkName: string, navLink: string) {
    this.menuService.setSelectedMenu(linkName);
    this.menuService.selectedMenu$.subscribe(menu => {
      this.selectedMenu = menu;
    });
    this.selectedNavLink = this.navLinks.find(link => link.name === this.selectedMenu);
    this.navigateFromMenu(navLink);
  }

  // Menu.hrefurl for "Home" is '/Home' for every role, which is not an Angular route (it 404'd);
  // 'AuditScheduling' is stored where the route is 'AuditSchedule'. Handle both here so the
  // sidebar works without a DB change in UAT/Live.
  // Home: the API (appsettings KeyValues:HomeUrl, differs UAT/Live) rewrites the Home menu item's
  // hrefurl to the environment's login page, an absolute URL. If HomeUrl is not configured the
  // item still arrives as '/Home', so fall back to the in-app /Login route.
  private navigateFromMenu(navLink: string): void {
    if (/^https?:\/\//i.test(navLink)) {
      const target = new URL(navLink);
      if (target.origin === window.location.origin) {
        // Same app (e.g. UAT's own /Login): route inside the SPA. A full page load briefly
        // rendered the logged-in shell while booting, and on Back restored the old page from the
        // browser cache with the session already cleared by the login page (blank tabs). In-app
        // routing lets roleGuard handle Back properly.
        this.router.navigateByUrl(target.pathname + target.search + target.hash);
      } else {
        window.location.href = navLink;
      }
      return;
    }
    if (navLink === '/Home') {
      this.router.navigate(['/Login']);
      return;
    }
    this.router.navigate([navLink === '/AuditScheduling' ? '/AuditSchedule' : navLink]);
  }

  onSidebarLinkClick(linkName: string, navLink: string) {
    this.selectedNavLink = this.navLinks.find(link => link.name === this.selectedMenu);
    this.menuService.setSelectedMenu(linkName);
    this.menuService.selectedMenu$.subscribe(menu => {
      this.selectedMenu = menu;
    });
    if (navLink) {
      this.navigateFromMenu(navLink);
    }
  }

  private sidebarClosedRoutes: string[] = [
    '/CustomerDashboard'
    // Add more routes here as needed
  ];

  isSidebarClosedRoute(route: string): boolean {
    return this.sidebarClosedRoutes.includes(route.split('?')[0]);
  }

  hideTabs(): boolean {
    const hiddenRoutes = ['/CustomerDashboard','/Dashboard','/DashboardGrid','/ContractorDashboard'];
    return !hiddenRoutes.includes(this.currentRoute?.split('?')[0] || '');
  }

  changePassword() {
    this.router.navigate(['/ChangePassword']);
  }
  closeAlert() {
    this.alertData = { alertMessage: '', alertVisible: '' }
  }

  handleWorkspaceClick(event: Event, hrefUrl: string) {
    event.preventDefault();
    this.sidebarTabMenuToggleWorkspace = !this.sidebarTabMenuToggleWorkspace;
    this.router.navigate([hrefUrl]);
  }
}
